import { generateStripeState } from '../helper'

const options = {
  api: {
    get: () => `/api/stripe/account`,
    // note, this is sort of hacky for now; Its the account of the tenant in the jwt token
    // we use the create as an update as well in this case, but we need the POST, which is why its a create
    create: () => `/api/stripe/account/requirements`
  },
  state: {
    collectionName: 'account'
  },
  getters: {
    getCollection: 'getAccounts'
  },
  actions: {
    get: 'getAccount',
    create: 'updateAccountRequirements'
  },
  mutationKey: 'ACCOUNT',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions,
    updateAccountSettings({}, data) {
      const { _headers: headers = {} } = data
      const payload = { ...data }
      const config = { headers }

      return this.$api.post('/api/stripe/account/settings', payload, config)
    }
  },
  mutations:{
    ...stripeMutations
  }
}
